import { useEffect, useState } from "react";
import { Link } from "react-router";
import { Pill } from "@astrum/ui";
import { api } from "../lib/api.js";
import { goalStatusLabel, goalStatusTone, progressLabel } from "../lib/goals.js";

type ContributingGoal = {
  id: string;
  title: string;
  periodLabel: string;
  progress: number | null;
  status: string;
};

/** The goals a project feeds. Renders nothing when there are none or they cannot be loaded. */
export function ProjectGoals({ projectId }: { projectId: string }) {
  const [goals, setGoals] = useState<ContributingGoal[]>([]);

  useEffect(() => {
    let cancelled = false;
    void api
      .get<{ goals: ContributingGoal[] }>(`/projects/${projectId}/goals`)
      .then((r) => {
        if (!cancelled) setGoals(r.goals);
      })
      .catch(() => {
        if (!cancelled) setGoals([]);
      });
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  if (goals.length === 0) return null;
  return (
    <section className="project-goals" aria-label="Goals this project contributes to">
      <h2>Goals</h2>
      <ul>
        {goals.map((g) => (
          <li key={g.id}>
            <Link to="/goals">{g.title}</Link>
            <span>{g.periodLabel}</span>
            <span>{progressLabel(g.progress)}</span>
            <Pill tone={goalStatusTone(g.status)} dot>
              {goalStatusLabel(g.status)}
            </Pill>
          </li>
        ))}
      </ul>
    </section>
  );
}
